"use strict";

let moduleName = 'menu';

module.exports = function () {
    $('a[href*="#"]').each(function () {
        if ($.data(this, moduleName + '-init')) return;
        $.data(this, moduleName + '-init', true);

        $(this).on('click', function (e) {
            let id = $(this).attr('href');
            if (id.length > 1) {
                e.preventDefault();
                $('body,html').stop().animate({scrollTop : $(id).offset().top}, 600);
                $('.header').removeClass('open');
                return false;
            }
        });
    });
};


// WEBPACK FOOTER //
// ./src/js/modules/menuInit.js